import {connect} from 'react-redux';
import ViewFile from './ViewFile';
import {getFile} from "../../actions/files/getFile";
import {showGlobalErrorMessage} from "../../actions/globalErrorMessage/showGlobalErrorMessage";

export default connect(
  null,
  {getFile, showGlobalErrorMessage}
)(ViewFile);
